import React, { useState } from 'react';
import Header from '../Components/Header'
import Button from '../Components/Button';
import { Carousel, Modal } from 'antd';
import { CAROUSEL_PACING } from '../config/carousel';
import { HAPPY_PAY_PUBLIC } from '../config/campaign';

const Home = () => {
  const [winnerModalOpen, setWinnerModalOpen] = useState(false);

  const winnerModalCancel = () => {
    setWinnerModalOpen(false);
  };

  let phase = 1
  const nowDate = new Date();
  const draw = new Date('2024-07-10T18:00:00');

  if (nowDate > draw) {
    phase = 2
  }

  return (
    <div className='h-screen w-full'>
      <Header />
      <Modal open={winnerModalOpen} onCancel={winnerModalCancel} footer={null} centered width={500} header={null} bodyStyle={{ height: '500px', margin: -24, padding: 0 }}>
        <div className='w-full h-full relative'>
          <div className='z-40 w-full h-full absolute flex justify-center items-center font-mont p-7 mobile:p-5'>
            <div className='w-full h-full backdrop-blur-md bg-white/30 border border-white rounded-[55px] flex flex-col space-y-12 mobile:space-y-10 justify-center items-center'>
            <p className='text-2xl text-white w-4/5 text-center font-semibold mobile:text-lg'>Хэрэв та 2024 оны 1, 2, 3 дугаар сарын урамшууллын эзэн болсон бол <span className='font-bold'>2024.04.15</span>-ны дотор баталгаажуулалт хийнэ үү.</p>
              <Button style="bg-gradient-to-r from-[#eeb86d] to-[#9946b2] text-white text-base font-semibold rounded-full w-[240px] mobile:w-[220px] h-12 mobile:h-10 shadow-lg transition hover:scale-105 duration-200 ease-in-out hover:text-white border border-white" name='Баталгаажуулах' link="https://www.cardcentre.mn/eregister/index.php?appid=happy_pay" />
              <p className='text-base text-white w-4/5 text-center mobile:text-sm'>Тус хугацаанд баталгаажуулалт хийхгүй бол таны дансанд урамшуулал шилжих боломжгүй болохыг анхаарна уу.</p>
            </div>
          </div>
          <img className='top-0 left-0 absolute w-full h-full object-cover z-10' src="/images/popup.png" />
        </div>
      </Modal>

      <div className='hidden mobile:block'>
        <Carousel autoplay waitForAnimate {...CAROUSEL_PACING}>
          {/*<div>*/}
          {/*  <a href="/infoapple" className='w-full h-[calc(100vh_-_96px)]'>*/}
          {/*    <img src="./apple_pay/june-update/apple-home-mobile.jpg"  className='h-full object-contain w-full'  alt="apple_pay"/>*/}
          {/*  </a>*/}
          {/*</div>*/}
          {HAPPY_PAY_PUBLIC && <div className='w-full h-[calc(100vh_-_96px)] object-cover'>
              <a href="/infohappy">
                  <img className="h-full object-cover w-full" src="./happy_pay_2026/1080x2160.jpg" alt="happy_pay"/>
              </a>
          </div>}
          {/*<div className='w-full h-[calc(100vh_-_96px)] object-cover'>*/}
          {/*  <a href='/infovisa'>*/}
          {/*    <img className='h-full object-cover w-full' src="images/dash_banner_3.png" alt="banner" />*/}
          {/*  </a>*/}
          {/*</div>*/}
          <div className='w-full h-[calc(100vh_-_96px)] object-cover'>
            <a href='/infosaving'>
              <img className='h-full object-cover w-full' src={phase == 1 ? "images/hm_home_m.png" : "images/HM-2026-1-Mobile.png"} alt="banner" />
            </a>
          </div>
          {/*<div>*/}
          {/*  <a href="/infomerchant" className='w-full h-[calc(100vh_-_96px)]'>*/}
          {/*    <img src="./images/happy_merchant_2025-mobile-1.png"  className='h-full object-cover w-full'  alt="merchant"/>*/}
          {/*  </a>*/}
          {/*</div>*/}
        </Carousel>
      </div>

      <div className='mobile:hidden'>
        <Carousel autoplay waitForAnimate {...CAROUSEL_PACING}>
          {/*<div>*/}
          {/*  <a className='w-full h-[calc(100vh_-_96px)] object-cover' href="/infoapple">*/}
          {/*    /!*<img src="./apple_pay/apple_home.png" className='w-full h-[calc(100vh_-_96px)] object-cover' alt="apple_pay"/>*!/*/}
          {/*    <img src="./apple_pay/june-update/apple-home.jpg" className='w-full h-[calc(100vh_-_96px)] object-cover' alt="apple_pay"/>*/}
          {/*  </a>*/}
          {/*</div>*/}
          {/* Both slides are 2.7:1 artwork, so both get the same ratio-driven box
              and the carousel keeps one height. Sizing these to the viewport
              instead — the old h-[calc(100vh-96px)] — gave the box whatever ratio
              the window happened to have (2.26:1 on this screen) and object-cover
              ate the difference: ~16% off the width, which is the trophy.
              max-h keeps a wide, short window from pushing the hero past the fold;
              only there does it crop, and by less. */}
          {/* The slide keeps the full hero height and centres the banner in it, so
              the leftover space from the ratio difference sits half above and half
              below rather than all below.

              Not centred: the header above is white too, so an even split reads as
              top-heavy — the gap above merges with the header into one white band
              while the gap below is bounded. The 1fr/3fr rows put a quarter of the
              slack above and three quarters below, which looks centred. A ratio
              rather than a fixed 25px so the weighting holds at any window height.

              `!grid` needs its important: antd's carousel styles set this wrapper
              to `display: inline-block` with a selector that outranks a plain
              utility class, and a non-grid container ignores the row template
              silently — the banner just stays at the top. */}
          {HAPPY_PAY_PUBLIC && <div className='h-[calc(100vh_-_96px)] !grid grid-rows-[1fr_auto_3fr]'>
              <a href="/infohappy" className='w-full row-start-2'>
                  <img src="./happy_pay_2026/3000x1110-3.jpg"
                       className='w-full aspect-[27/10] max-h-[calc(100vh_-_96px)] object-cover' alt="happy_pay"/>
              </a>
          </div>}
          <div className='h-[calc(100vh_-_96px)] !grid grid-rows-[1fr_auto_3fr]'>
            <a href='/infosaving' className='w-full row-start-2'>
              <img className='w-full aspect-[27/10] max-h-[calc(100vh_-_96px)] object-cover'
                   src={phase == 1 ? "images/SM-2024.png" : "images/HM-2026-2.jfif"} alt="banner"/>
            </a>
          </div>

          {/*<div className='w-full h-[calc(100vh_-_96px)] object-cover'>*/}
          {/*  <a href='/infovisa'>*/}
          {/*    <img className='h-full object-cover w-full' src="images/bannerv2.jpg" alt="banner"/>*/}
          {/*  </a>*/}
          {/*</div>*/}
          {/*<div>*/}
          {/*  <a className='w-full h-[calc(100vh_-_96px)] object-cover' href="/infomerchant">*/}
          {/*    <img src="./images/Happy Merchant AP pos banner.png" className='w-full h-[calc(100vh_-_96px)] object-cover' alt="merchant"/>*/}
          {/*  </a>*/}
          {/*</div>*/}
        </Carousel>
      </div>
    </div>
  );
}

export default Home;